var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEstimateAccepted = function SvgEstimateAccepted(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_17532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9492 20.5962C20.9492 20.9532 20.8074 21.2956 20.5549 21.548C20.3025 21.8005 19.9601 21.9423 19.6031 21.9423H4.79537C4.43835 21.9423 4.09595 21.8005 3.8435 21.548C3.59105 21.2956 3.44922 20.9532 3.44922 20.5962V3.09615C3.44922 2.73913 3.59105 2.39673 3.8435 2.14428C4.09595 1.89183 4.43835 1.75 4.79537 1.75H14.3342C14.691 1.75008 15.0331 1.89178 15.2855 2.14397L20.5552 7.41372C20.8074 7.66608 20.9491 8.00823 20.9492 8.365V20.5962Z",
    stroke: "#8290A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9495 8.48077H15.5649C15.2079 8.48077 14.8655 8.33894 14.613 8.08649C14.3606 7.83404 14.2188 7.49164 14.2188 7.13462V1.75",
    stroke: "#8290A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99394 11.4816C7.1883 11.7369 7.44133 11.9416 7.73159 12.0783C8.02185 12.2149 8.34079 12.2797 8.66138 12.2669C9.68356 12.2669 10.5128 11.645 10.5128 10.8786C10.5128 10.1121 9.68625 9.49112 8.66497 9.49112C7.64368 9.49112 6.81445 8.86919 6.81445 8.10188C6.81445 7.33458 7.64368 6.71355 8.66497 6.71355C8.98558 6.70055 9.3046 6.76516 9.5949 6.90187C9.8852 7.03858 10.1382 7.24336 10.3324 7.49881",
    stroke: "#8290A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 12.2666V13.1919",
    stroke: "#8290A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 5.78809V6.71334",
    stroke: "#8290A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1992 14.5381H17.5838",
    stroke: "#8290A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48828 18.5771H17.5844",
    stroke: "#8290A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.1992,
    cy: 6,
    r: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1992 0C14.8855 0 12.1992 2.68629 12.1992 6C12.1992 9.31371 14.8855 12 18.1992 12C21.5129 12 24.1992 9.31371 24.1992 6C24.1992 2.68629 21.5129 0 18.1992 0ZM20.7235 5.22426C20.9578 4.98995 20.9578 4.61005 20.7235 4.37574C20.4892 4.14142 20.1093 4.14142 19.875 4.37574L17.2992 6.95147L16.2235 5.87574C15.9892 5.64142 15.6093 5.64142 15.375 5.87574C15.1406 6.11005 15.1406 6.48995 15.375 6.72426L16.875 8.22426C17.1093 8.45858 17.4892 8.45858 17.7235 8.22426L20.7235 5.22426Z",
    fill: "#409C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_17532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.199219)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEstimateAccepted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/estimate-accepted.eec75a4e.svg";
export { ForwardRef as ReactComponent };